












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class LoadingTextWave extends Vue {
  @Prop({ required: false }) text: string | undefined;

  get textArray(): string[] {
    const textArray = [];
    if (this.text) {
      textArray.push(...this.text!.split(""));
    } else {
      textArray.push(..."LOADING...".split(""));
    }
    return textArray;
  }
}
